import IGlobalState from '@/interfaces/IGlobalState';
import { LanguageEnum } from '@/enums/LanguageEnum';
import ITrafficLegendItem from '@/interfaces/ITrafficLegendItem';
import {IOpenWeather} from '@/interfaces/IOpenWeather';

export default {
  getDrawerActive(state: IGlobalState): boolean {
    return state.drawerActive;
  },
  getPosition(state: IGlobalState): {lat: number, lng: number} {
    return {
      lat: state.position.lat,
      lng: state.position.lng,
    };
  },
  getZoomFactor: (state: IGlobalState): number => state.zoomFactor,
  getContrastActive(state: IGlobalState): boolean {
    return state.contrast;
  },
  getFlipResizeActive(state: IGlobalState): number {
    return state.fontSize;
  },
  getCurrentLang(state: IGlobalState): LanguageEnum {
    return state.currentLang;
  },
  getTrafficLegend(state: IGlobalState): object {
    return state.segmentsConfig.values;
  },
  getOpenWeather(state: IGlobalState): IOpenWeather {
    return state.openWeather;
  },
  getNavActiveTab: (state: IGlobalState): number|null => state.navActiveTab,
  
  isMapLayerShown: (state: IGlobalState) => (key: string): boolean | undefined => {
    return state.settings.map[key];
  }
};
